export default __webpack_public_path__ + "static/media/lukasz-szmigiel-jFCViYFYcus-unsplash.69aba6e3.jpg";